// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SGZo","option":"styles_option__4IoR3","selected":"styles_selected__1Dy-V"};